import { eudraResultsUISchema } from "./eudraResultsUISchema"
import { ctisProtocolUISchema } from "../protocol/ctisProtocolUISchema"
import { ctgProtocolUISchema } from "../protocol/ctgProtocolUISchema"

import { protocolClassNames } from "../classes"
import { setHiddenFields } from "../protocol/utils/utils"

const hideFields = {
  protocol: {
    root: [
      "protocol_id",
      "type_of_research",
      "study_type",
      // "eudract_number",
      "contact_information",
      "study_oversight",
      "milestone_dates",
      "study_arms",
      "investigator_information",
      "non_investigator_information",
      "information_on_multicenter_clinical_trials",
      "overview_of_pharmaceuticals",
      "monetary_sponsor",
      "irb_information",
      "ema_hma_additional_information",
      "study_identification",
      "study_details",
      "study_timeline",
      "study_description",
      "study_ipd",
      "study_outcome_measures",
      "study_details",
      "ctis_form",
      "mscs",
      "study_reference",
      "secondary_attributes",
    ],
    study_scope: {
      root: [
        "scope_of_study",
        "other_scope_description",
        "design_of_study",
        // "other_design_description",
        "trial_scope",
        "ctis_trial_phase",
        "periods",
        "countries_outside_eea",
        "control",
        "placebo",
        "blinding",
        "randomization",
        "non_insurance_combined_medical_expenses",
        "countries_of_recruitment_except_japan",
        "jrct_masking",
        "clinical_trial_regulatory_scope",
        "clinical_trial_type",
        "data_collection_method",
        "other_non_interventional_study_design",
        "masking",
        "number_of_arms",
        "patient_registry",
        "masking_description",
        "allocation",
        "enrollment_type",
        "enrollment_type_obs",
        "follow_up_duration",
        "duration_type",
        "additional_patient_registry_data",
        "observational_study_model",
        "time_perspective",
        "biospecimen",
        "enrollment_number",
        "number_of_cohorts",
        "selection",
      ],
    },
    study_eligibilty: {
      root: [
        "gender_based",
        "age_limits",
        "accept_healthy_volunteers",
        "is_clinical_study",
        "study_population_description",
        "sampling_method",
        "population_under_study",
        "sex",
        "sources_of_data",
        "registered_data_sources",
        "other_registered_data_sources",
        "other_data_source",
        "short_description_of_study_population",
        "age_groups",
        "special_interest_of_population",
        "other_special_interest_of_population",
      ],
    },
  },
}

export const ctisResultsUiSchema = (configs) => {
  const eudractResultsUiSchema = eudraResultsUISchema(configs)
  const ctisProtocolUiSchema = ctisProtocolUISchema(configs)
  const ctgProtocolUiSchema = ctgProtocolUISchema(configs)

  return {
    "ui:options": {
      classNames: protocolClassNames,
    },
    protocol: {
      ...ctisProtocolUiSchema.protocol,
      "ui:order": ["study_scope", "study_eligibilty", "*"],
      "ui:options": {
        classNames: protocolClassNames,
      },
      study_scope: {
        ...ctgProtocolUiSchema.protocol.study_scope,
        "ui:options": {
          ...ctgProtocolUiSchema.protocol.study_scope["ui:options"],
          title: "Trial Information (Part 1)",
          classNames: protocolClassNames,
        },
        primary_purpose: ctgProtocolUiSchema.protocol.study_scope.primary_purpose,
        study_phase: ctgProtocolUiSchema.protocol.study_scope.study_phase,
        interventional_study_model: ctgProtocolUiSchema.protocol.study_scope.interventional_study_model,
        model_description: ctgProtocolUiSchema.protocol.study_scope.model_description,
        ...setHiddenFields(hideFields.protocol.study_scope.root),
      },
      study_eligibilty: {
        ...ctgProtocolUiSchema.protocol.study_eligibilty,
        eligibility_criteria: ctgProtocolUiSchema.protocol.study_eligibilty.eligibility_criteria,
        ...setHiddenFields(hideFields.protocol.study_eligibilty.root),
      },
      ...setHiddenFields(hideFields.protocol.root),
    },
    results: eudractResultsUiSchema.results,
  }
}
